import { StyledDrawer } from 'shared/components/Sidebar/Sidebar.styles'

import { Handler } from '../../helpers/typeHelper'
import { white } from '../../theme/colors'
import { SIDEBAR_WIDTH } from './Notes.constants'

type Props = {
  isExpanded: boolean
  handleClose: Handler
  renderNotesList: () => React.ReactNode
  children: () => React.ReactNode
}

export function NotesSidebar({ isExpanded, handleClose, renderNotesList, children }: Props) {
  return (
    <>
      {children()}
      <StyledDrawer
        isOpen={isExpanded}
        onClose={handleClose}
        width={SIDEBAR_WIDTH}
        children={renderNotesList}
        withOverlay={false}
        bgColor={white}
      />
    </>
  )
}
